import { Component, Element, h, Host, Prop } from '@stencil/core'

import Helpers from '../../../utils/helpers'
import { CssClassMap } from '../../../utils/interfaces'

/**
 * ## Design System
 *
 * Para a documentação completa de design, incluindo diretrizes de uso, acessibilidade e exemplos visuais, consulte o [Design System do GovBR](https://www.gov.br/ds/components/footer?tab=designer).
 *
 * @slot default - Slot para o conteúdo do item no rodapé, incluindo texto ou componentes de roteamento para SPAs.
 */
@Component({
  tag: 'br-footer-item',
  styleUrl: 'footer-item.scss',
  shadow: true,
})
export class FooterItem {
  /**
   * Referência ao elemento host do componente.
   * Utilize esta propriedade para acessar e manipular o elemento do DOM associado ao componente.
   */
  @Element() el: HTMLBrFooterItemElement

  /**
   * Identificador único.
   * Caso não seja fornecido, um ID gerado automaticamente será usado.
   */
  @Prop({ reflect: true }) readonly customId: string = Helpers.generateUniqueId()

  /**
   * URL ou caminho para o qual o usuário será direcionado ao clicar no item.
   * Quando definido, o item será renderizado como um link.
   */
  @Prop({ reflect: true }) readonly href?: string

  /**
   * Monta o objeto com as classes CSS do componente
   * @returns Objeto com as classes CSS do componente
   */
  private getCssClassMap(): CssClassMap {
    return {
      'br-footer-item': true,
    }
  }

  /**
   * Renderiza o componente
   * @returns JSX do componente
   */
  render() {
    return (
      <Host>
        <br-item id={this.customId} href={this.href} role="listitem" class={this.getCssClassMap()}>
          <slot></slot>
        </br-item>
      </Host>
    )
  }
}
